// extracted by mini-css-extract-plugin
export default {"inner":"banner_inner__Gc1gj"};